import React from 'react';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

function SuccessScreen({ imageSrc = '/images/success_screen.svg', title, desc }) {
    return (
        <>
            <Typography mb={1} color="text.secondary" variant="h4" fontWeight="bold" sx={{ fontSize: '24px' }}>
                {title}
            </Typography>
            <Typography mb={1} color="text.secondary" variant="h4" sx={{ fontSize: '14px' }}>
                {desc}
            </Typography>
            <img src={imageSrc} alt="success" data-testid="success-screen" style={{ width: '90%', height: 'auto' }} />
        </>
    );
}

SuccessScreen.propTypes = {
    imageSrc: PropTypes.string,
    title: PropTypes.string,
    desc: PropTypes.string,
};

SuccessScreen.defaultProps = {
    title: '',
    desc: '',
    imageSrc: '/images/success_screen.svg',
};

export default SuccessScreen;
